import { map } from 'rxjs/operators';
export var errorWhen = function (predicate, errorOrFactory) {
    if (errorOrFactory === void 0) { errorOrFactory = new Error(); }
    return map(function (value) {
        if (predicate(value)) {
            throw typeof errorOrFactory === 'function' ? errorOrFactory(value) : errorOrFactory;
        }
        return value;
    });
};
//# sourceMappingURL=errorWhen.js.map